import React, { memo, useState, useContext, useRef, useEffect } from 'react'
import {
  Button,
  Link,
  DropdownMenu,
  HeadingText,
  Tooltip,
  TextInput,
  TextArea,
  CaptionText,
  Alert,
} from '@paypalcorp/pp-react'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import ReCAPTCHA from 'react-google-recaptcha'
import { isEmail, isEmptyOrWhiteSpace } from '../../../utils/validation'
import {
  serverData,
  fptiCustomSetup,
  fptiCustomClick,
  getFeatureValue,
} from '../../../utils'

import { ZETTLE_SUBMIT_API } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import DsrBanner from '../common/dsr-banner'
import Spinner from '../common/dsr-spinner'

const dsrRecaptchaKey = getFeatureValue('dsrRecaptchaSiteKey')
const recaptchaFlag = getFeatureValue('recaptchaFlagToDisplay')

const optionsToData = [
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.erasure" />,
    value: 'DATA_ERASURE',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.access" />,
    value: 'DATA_ACCESS_REQUEST',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.be.informed" />,
    value: 'DATA_INFORMATION',
  },
  {
    primaryText: (
      <Message id="dsrZettle.form.common.right.to.data.processing" />
    ),
    value: 'DATA_RESTRICTION',
  },
  {
    primaryText: (
      <Message id="dsrZettle.form.common.right.to.data.portability" />
    ),
    value: 'DATA_PORTABILITY',
  },
  {
    primaryText: <Message id="dsrZettle.form.common.right.to.correction" />,
    value: 'DATA_CORRECTION',
  },
]

const userObj = {
  fname: '',
  lname: '',
  requestType: '',
  email: '',
  correctionData: '',
  captchaToken: '',
}

let validateObj = { ...userObj }

const DataRequestForm = memo((props) => {
  const worldReady = useContext(WorldReadyContext)
  const [selectedItem, setSelectedItem] = useState()
  const [comments, setComments] = useState(false)
  const [isErrOnWhatdata, setErrOnWhatdata] = useState(false)
  const [isErrOnFname, setErrOnFname] = useState(false)
  const [isErrOnLname, setErrOnLame] = useState(false)
  const [isErrOnEmail, setErrOnEmail] = useState(false)
  const [isErrOnCaptcha, setErrOnCaptcha] = useState(false)
  const [isErrOnComments, setErrOnComments] = useState(false)
  const [isErrOnMaxLimitComments, setErrOnMaxLimitComments] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [impressionDone, setImpressionDone] = useState(false)
  const [formValues, setFormValues] = useState(userObj)

  const maxCharacters = 250
  const { dsrFpti = {} } = props
  const recaptchaRef = useRef(null)
  window.recaptchaOptions = {
    useRecaptchaNet: true,
  }

  const validateFields = () => {
    let reqType_el = isEmptyOrWhiteSpace(userObj.requestType)
    let fname_el = isEmptyOrWhiteSpace(userObj.fname)
    let lname_el = isEmptyOrWhiteSpace(userObj.lname)
    let email_el = isEmptyOrWhiteSpace(userObj.email)
    let captcha_el = isEmptyOrWhiteSpace(userObj.captchaToken)
    let isvalidEmail = isEmail(userObj.email)

    validateObj = {
      fname: fname_el,
      lname: lname_el,
      requestType: reqType_el,
      captcha: captcha_el,
    }

    setErrOnWhatdata(reqType_el)
    setErrOnFname(fname_el)
    setErrOnLame(lname_el)
    setErrOnCaptcha(captcha_el)
    if (email_el) {
      validateObj = {
        ...validateObj,
        email: email_el,
      }
      setErrOnEmail(email_el)
    } else {
      validateObj = {
        ...validateObj,
        email: isvalidEmail,
      }
      setErrOnEmail(isvalidEmail)
    }

    if (comments) {
      let comments_el = isEmptyOrWhiteSpace(userObj.correctionData)
      validateObj = {
        ...validateObj,
        correctionData: comments_el,
      }
      setErrOnComments(comments_el)
    }
  }
  async function postDARRequest(reqparams) {
    fptiCustomClick(dsrFpti.SUBMIT_BTN)
    setShowSpinner(true)
    let response = await post(ZETTLE_SUBMIT_API, reqparams)
    if (response && response.success) {
      setShowAlert(false)
      props.changeState('SUCCESS')
    } else {
      setShowSpinner(false)
      setShowAlert(true)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setShowAlert(false)

    if (recaptchaFlag) {
      const ctoken = recaptchaRef.current.getValue()
      userObj.captchaToken = ctoken
    } else {
      userObj.captchaToken = 'testvalue'
    }

    validateFields()
    let isValid = Object.keys(validateObj).some(
      (item) => validateObj[item] === true,
    )
    let reqparams = {
      _csrf: serverData._csrf,
      fields: JSON.stringify(userObj),
    }

    if (!isValid) {
      postDARRequest(reqparams)
    }
  }
  const handleSelection = (index) => {
    userObj.correctionData = ''
    if (optionsToData[index].value === 'DATA_CORRECTION') {
      setComments(true)
    } else {
      setComments(false)
    }
    userObj.requestType = optionsToData[index].value
    setSelectedItem(index)
  }

  const handleChange = (evt) => {
    userObj[evt.target.name] = evt.target.value

    if (comments) {
      setErrOnMaxLimitComments(evt.target.value.length > maxCharacters)
    } else {
      setErrOnMaxLimitComments(false)
    }
  }

  const ddmenuAccessLable = new MessageFormat(worldReady, {
    id: 'dsrZettle.form.common.right.to.ex.label',
  }).format()

  const getErrorText = () => {
    let text = ''
    if (isErrOnComments) {
      text = (
        <Message id="dsrZettle.form.common.info.to.correct.validation.required" />
      )
    } else if (isErrOnMaxLimitComments) {
      text = (
        <Message id="dsrZettle.form.common.info.to.correct.validation.max.length.250" />
      )
    } else {
      text = ''
    }
    return text
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.CASECREATION_IMPRESSION)
    }
    setFormValues(userObj)
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: <Message id="dsrZettle.landing.header.title" />,
    description: <Message id="dsrZettle.landing.header.description" />,
  }
  const onClickPrivacyLink = () => {
    fptiCustomClick(dsrFpti.PRIVACY_LINK)
  }
  return (
    <>
      {showSpinner && <Spinner />}
      {!showSpinner && (
        <>
          <DsrBanner {...bannerContent} />
          <section className="page-body-container">
            <div className="inner-container">
              <section className="data-request-page">
                <HeadingText size="md">
                  <Message id="dsrZettle.form.body.title" />
                </HeadingText>

                <form className="darform">
                  {showAlert && (
                    <Alert
                      theme="v2"
                      className="requestForm-row"
                      type="error"
                      closeButton={{
                        onClick: () => {
                          setShowAlert(false)
                        },
                      }}
                    >
                      <Message id="dsrZettle.common.error.technical" />
                    </Alert>
                  )}{' '}
                  <div>
                    <DropdownMenu
                      theme="v2"
                      name="what-data"
                      label={ddmenuAccessLable}
                      errorText={
                        isErrOnWhatdata ? (
                          <Message id="dsrZettle.form.common.right.to.ex.validation.required" />
                        ) : (
                          ''
                        )
                      }
                      selectedItemIndex={selectedItem}
                      options={optionsToData}
                      onSelection={handleSelection}
                    />
                  </div>
                  {comments && (
                    <div>
                      <section>
                        <TextArea
                          name="correctionData"
                          label={
                            <Message id="dsrZettle.form.common.info.to.correct.placeholder" />
                          }
                          defaultValue={formValues && formValues.correctionData}
                          onChange={handleChange}
                          showCharacterCounter
                          maxCharacters={maxCharacters}
                          errorText={getErrorText()}
                          theme="v2"
                          rightIcon={
                            <Tooltip
                              theme="v2"
                              description={
                                <Message id="dsrZettle.form.common.info.to.correct.tooltip" />
                              }
                              className="comments-tooltip-icon"
                            />
                          }
                        />
                      </section>
                    </div>
                  )}
                  <div>
                    <TextInput
                      name="fname"
                      label={
                        <Message id="dsrZettle.form.common.first.name.label" />
                      }
                      defaultValue={formValues && formValues.fname}
                      theme="v2"
                      onChange={handleChange}
                      errorText={
                        isErrOnFname ? (
                          <Message id="dsrZettle.form.common.first.name.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  <div>
                    <TextInput
                      name="lname"
                      label={
                        <Message id="dsrZettle.form.common.last.name.label" />
                      }
                      theme="v2"
                      defaultValue={formValues && formValues.lname}
                      onChange={handleChange}
                      errorText={
                        isErrOnLname ? (
                          <Message id="dsrZettle.form.common.last.name.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  <div>
                    <TextInput
                      name="email"
                      label={<Message id="dsrZettle.form.common.email.label" />}
                      theme="v2"
                      onChange={handleChange}
                      defaultValue={formValues && formValues.email}
                      errorText={
                        isErrOnEmail ? (
                          <Message id="dsrZettle.form.common.email.validation.required" />
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                  {recaptchaFlag && (
                    <div className="zettle-captcha-center">
                      <div>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={dsrRecaptchaKey.sitekey || ''}
                        />

                        {isErrOnCaptcha ? (
                          <div
                            className="ppvx_text-input__error-text___3-12-10 ppvx_text-input__error-icon___3-12-10"
                            role="alert"
                          >
                            <Message id="dsrZettle.form.captcha.required" />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  )}
                  <div className="text-center">
                    <Button theme="v2" id="submitbtn" onClick={handleSubmit}>
                      <Message id="dsrZettle.form.common.submit.btn" />
                    </Button>
                  </div>
                </form>
                <div>
                  <CaptionText className="text-center">
                    <Message
                      id="dsrZettle.form.common.terms.and.conditions"
                      link={(innerMessage) => (
                        <Link
                          href={`https://${serverData.cdnPayPalDomain}/en/webapps/mpp/ua/privacy-full#3`}
                          onClick={onClickPrivacyLink}
                          id="privacy_statment_link"
                          theme="v2"
                        >
                          {innerMessage}
                        </Link>
                      )}
                    />
                  </CaptionText>
                </div>
              </section>
            </div>
          </section>
        </>
      )}
    </>
  )
})
DataRequestForm.displayName = 'DataRequestForm'

export default DataRequestForm
